<template>
  <div v-if="show">
    <van-floating-bubble
      axis="xy"
      icon="medal-o"
      magnetic="x"
      @click="clickTask"
      :class="[
        'text-primary-content bg-primary',
        isTaskPage ? '!opacity-20' : '',
      ]"
      :offset="offset"
      @offset-change="onOffsetChange"
    />
    <VanPopup
      v-model:show="modalStore.showTaskPageModal"
      position="bottom"
      class="h-[90%]"
    >
      <UserTask v-if="modalStore.showTaskPageModal" />
    </VanPopup>
  </div>
</template>

<script setup lang="ts">
import { useGlobalUser } from "@/stores/globalUser";
import { useRoute } from "vue-router";
import { computed, onMounted, ref } from "vue";
import UserTask from "@/views/User/UserTask.vue";
import { useGlobalModal } from "@/stores/globalModal";
const route = useRoute();
const userStore = useGlobalUser();
const offset = ref({ x: 0, y: 0 });
const modalStore = useGlobalModal();

const isTaskPage = computed(() => route.name === "userTask");

const show = computed(() => {
  return userStore.isLogin && (userStore.user.extraConfig?.taskScreen ?? true);
});

const clickTask = () => {
  if (isTaskPage.value) return;
  modalStore.showTaskPageModal = true;
};

// 检查并调整位置，确保在屏幕范围内
const adjustPosition = () => {
  const maxX = window.innerWidth - 72;
  const maxY = window.innerHeight - 128;
  const minX = 24;
  const minY = 24;

  let needAdjust = false;

  // 检查 x 坐标
  if (offset.value.x < minX || offset.value.x > maxX) {
    offset.value.x = maxX; // 默认右下方
    needAdjust = true;
  }

  // 检查 y 坐标
  if (offset.value.y < minY || offset.value.y > maxY) {
    offset.value.y = maxY; // 默认右下方
    needAdjust = true;
  }

  // 如果位置被调整了，保存新的位置
  if (needAdjust) {
    onOffsetChange();
  }
};

onMounted(() => {
  // 默认是右下方
  offset.value.x = window.innerWidth - 72;
  offset.value.y = window.innerHeight - 128;

  // 如果有用户保存的位置，先设置然后检查是否有效
  if (userStore.user.extraConfig?.taskScreenX) {
    offset.value.x = userStore.user.extraConfig?.taskScreenX as number;
  }
  if (userStore.user.extraConfig?.taskScreenY) {
    offset.value.y = userStore.user.extraConfig?.taskScreenY as number;
  }

  // 检查位置是否超过屏幕尺寸，如果是就还原到默认位置
  adjustPosition();

  window.addEventListener("resize", () => {
    adjustPosition();
  });
});

const onOffsetChange = (_offset: { x: number; y: number } = offset.value) => {
  offset.value = _offset;
  userStore.updateUserExtraConfig({
    taskScreenX: _offset.x,
    taskScreenY: _offset.y,
  });
};
</script>
